export const CLINIC_DETAILS_REQUESTED = 'CLINIC_DETAILS_REQUESTED'
export const REDIRECT_TO_SPECIALTY_SERVICES = 'REDIRECT_TO_SPECIALTY_SERVICES'
export const REDIRECT_TO_MH_BOT_INFO = 'REDIRECT_TO_MH_BOT_INFO'

export const HYPERTENSION_CLICKED = 'HYPERTENSION_CLICKED'
export const MENTALHEALTH_CLICKED = 'MENTALHEALTH_CLICKED'
export const DIABETES_CLICKED = 'DIABETES_CLICKED'
export const DIABETES_BOT_INITED = 'DIABETES_BOT_INITED'
export const DIABETES_BOT_INVITATION_ID_ADDED =
  'DIABETES_BOT_INVITATION_ID_ADDED'
export const SHOW_DM_UPLOAD_FILE_REQUESTED_TYPE =
  'SHOW_DM_UPLOAD_FILE_REQUESTED_TYPE'
export const HTN_FOLLOWUP_BOT_START_CLICKED = 'HTN_FOLLOWUP_BOT_START_CLICKED'
export const SPECIALTY_SERVICES_CLICKED = 'SPECIALTY_SERVICES_CLICKED'
export const PRIMARY_CLINIC_CLICKED = 'PRIMARY_CLINIC_CLICKED'
export const HTN_BOT_INITED = 'HTN_BOT_INITED'
export const HTN_BOT_INVITATION_ID_ADDED = 'HTN_BOT_INVITATION_ID_ADDED'
export const MH_BOT_INVITATION_ID_ADDED = 'MH_BOT_INVITATION_ID_ADDED'
export const MH_FOLLOW_UP_BOT_INVITATION_ID_ADDED =
  'MH_FOLLOW_UP_BOT_INVITATION_ID_ADDED'
export const MENTALHEALTH_BOT_INITED = 'MENTALHEALTH_BOT_INITED'

export const NO_SHIFTS = 'NO_SHIFTS'
export const BOT_ABORTED = 'BOT_ABORTED'
export const UPDATE_INVITATION_RECEIVED = 'UPDATE_INVITATION_RECEIVED'
export const UPDATE_INVITATION_REQUESTED = 'UPDATE_INVITATION_REQUESTED'

export const RISK_ASSESMENT_BOT_STARTED = 'RISK_ASSESMENT_BOT_STARTED'
export const RISK_ASSESMENT_BOT_ENDED = 'RISK_ASSESMENT_BOT_ENDED'

export const HMO_BOT_STARTED = 'HMO_BOT_STARTED'
